
const AboutData = [
    {
        id: 1,
        name: "Adnan Abbas",
        dp1: "A",
        age: 19,
        triggre : false,
        gender: "male",
        pos: "CEO",
        salary: "42000",
        ph: "(+92)-3483458098",
        qualification: "BS-SE",
        image: "https://img.freepik.com/free-photo/elegant-businessman-office_155003-9641.jpg?t=st=1653592264~exp=1653592864~hmac=0fa56d8352203fe1c85825f7e4be7328abe559860bc66f8e5b5863447c7c9460&w=740",
        des: "Adnan is the CEO of Styles. He is very honest hard work. He has been working in this company for the last 9 years "
        },
        
        {
            id: 2,
            name: "Umer Cheema",
            dp1: "U",
            age: 19,
            triggre : false,
            gender: "male",
            pos: "Manager",
            salary: "34000",
            ph: "(+92)-3483825865",
            qualification: "BS-SE",
            image: "https://img.freepik.com/free-photo/businessman-black-suit-promoting-something_114579-15897.jpg?t=st=1653592264~exp=1653592864~hmac=b6996056e56b59e6fe52149776c6d05709fe20e3678a369072929ebb90e8142e&w=740",
            des: "Umer is the Manager of Styles. He is very honest hard work. He has been working in this company for the last 7 years "
            },

    {
        id: 3,
name: "Hamza",
dp1: "H",
age: 18,
triggre : false,
gender: "male",
pos: "Manager",
salary: "32000",
ph: "(+92)-3456388702",
qualification: "BS-SE",
image: "https://img.freepik.com/free-photo/serious-elegant-bearded-male-wearing-classic-waistcoat-slim-bow-tie_613910-1520.jpg?t=st=1653592264~exp=1653592864~hmac=403c3ba3a23e877be78daeb92e9288be234878b973e37bd35794ddf99116d1e8&w=740",
des: "Hamza is worked as a Manager in Styles. He is very honest hard work. He has been working in this company for the last 3 years "

},

{
    id: 4,
    name: "Hassan Raza Tahir",
    dp1: "H",
    age: 20,
    gender: "male",
    triggre : false,
    pos: "Manager",
    salary: "32000",
    ph: "(+92)-3396434702",
    qualification: "BS-SE",
    image: "https://img.freepik.com/free-photo/male-beauty-concept-portrait-fashionable-young-man-with-stylish-haircut-wearing-trendy-suit-posing-black-studio-background_155003-21656.jpg?t=st=1653592264~exp=1653592864~hmac=d2505313f73cc385867d7c873d255bf2b5dcdb0c11b1e7dd681d34ca05950ec3&w=740",
    des: "Hassan is worked as a Manager in Styles. He is very honest hard work. He has been working in this company for the last 5 years "
    
    },

{
    id: 5,
    name: "Waleed Qadeer",
    dp1: "W",
    age: 19,
    gender: "male",
    triggre : false,
    pos: "Sales Manager",
    salary: "24000",
    ph: "(+92)-3345688702",
    qualification: "BS-SE",
    image: "https://img.freepik.com/free-photo/handsome-smiling-bearded-man-glasses-working-laptop_285396-9838.jpg?t=st=1653592264~exp=1653592864~hmac=d58af00d2ce97db7bab1bb781f1e12c468e8ed3cc48e1afd170dd6d24687b8d5&w=740",
    des: "Waleed is worked as a Peon in Styles. He is very honest hard work. He has been working in this company for the last 1 years "
    
    },


    {
        id: 6,
        name: "Muhammad Shaharyar",
        dp1: "S",
        age: 20,
        triggre : false,
        gender: "male",
        pos: "Sales Manager",
        salary: "32000",
        ph: "(+92)-3396434702",
        qualification: "BS-SE",
        image: "https://img.freepik.com/free-photo/business-concept-happy-young-businessmanman-smart-suit-typing-sms-gray-background_1258-80741.jpg?t=st=1653592264~exp=1653592864~hmac=712af8962f97f7565eb05ac2139eeea4f3178f85c1b28ee4220a9d1f7351f51b&w=740",
        des: "Shaharyar is worked as a Sales Manager in Styles. He is very honest hard work. He has been working in this company for the last 2 years "
        
        },


]



export default AboutData;